import ConsentBox from "../Fusion/Component/CookieBox/ConsentBox";

window.cookieBox = new ConsentBox();
